 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import XHTML01COVER from '@/components/xhtml/01-cover'
 import XHTML02FRONTMATTER from '@/components/xhtml/02-frontmatter'
 import XHTMLLOVE_1 from '@/components/xhtml/love_1'
 import XHTML03TITLE from '@/components/xhtml/03-title'
 import XHTML04DEDICATION from '@/components/xhtml/04-dedication'
 import XHTML05COPYRIGHT from '@/components/xhtml/05-copyright'
 import XHTML06ACKNOWLEDGMENTS from '@/components/xhtml/06-acknowledgments'
 import XHTML07CONTENTS from '@/components/xhtml/07-contents'
 import XHTML08FOREWORD from '@/components/xhtml/08-foreword'
 import XHTML09INTRODUCTION from '@/components/xhtml/09-introduction'
 import XHTML10CHAPTER01 from '@/components/xhtml/10-chapter01'
 import XHTML11CHAPTER01A from '@/components/xhtml/11-chapter01a'
 import XHTML12CHAPTER01B from '@/components/xhtml/12-chapter01b'
 import XHTML13CHAPTER02 from '@/components/xhtml/13-chapter02'
 import XHTML14CHAPTER02A from '@/components/xhtml/14-chapter02a'
 import XHTML15CHAPTER02B from '@/components/xhtml/15-chapter02b'
 import XHTML16CHAPTER02C from '@/components/xhtml/16-chapter02c'
 import XHTML17CHAPTER02D from '@/components/xhtml/17-chapter02d'
 import XHTML18CHAPTER02E from '@/components/xhtml/18-chapter02e'
 import XHTML19CHAPTER02F from '@/components/xhtml/19-chapter02f'
 import XHTML20CHAPTER02G from '@/components/xhtml/20-chapter02g'
 import XHTML21CHAPTER02H from '@/components/xhtml/21-chapter02h'
 import XHTML22CHAPTER02I from '@/components/xhtml/22-chapter02i'
 import XHTML23CHAPTER02J from '@/components/xhtml/23-chapter02j'
 import XHTML24CHAPTER02K from '@/components/xhtml/24-chapter02k'
 import XHTML25CHAPTER02L from '@/components/xhtml/25-chapter02l'
 import XHTML26CHAPTER02M from '@/components/xhtml/26-chapter02m'
 import XHTML27CHAPTER03 from '@/components/xhtml/27-chapter03'
 import XHTML28CHAPTER03A from '@/components/xhtml/28-chapter03a'
 import XHTML29CHAPTER03B from '@/components/xhtml/29-chapter03b'
 import XHTML30CHAPTER03C from '@/components/xhtml/30-chapter03c'
 import XHTML31CHAPTER03D from '@/components/xhtml/31-chapter03d'
 import XHTML32CHAPTER03E from '@/components/xhtml/32-chapter03e'
 import XHTML33CHAPTER03F from '@/components/xhtml/33-chapter03f'
 import XHTML34CHAPTER03G from '@/components/xhtml/34-chapter03g'
 import XHTML35CHAPTER03H from '@/components/xhtml/35-chapter03h'
 import XHTML36CHAPTER03I from '@/components/xhtml/36-chapter03i'
 import XHTML37CHAPTER03J from '@/components/xhtml/37-chapter03j'
 import XHTML38CHAPTER03K from '@/components/xhtml/38-chapter03k'
 import XHTML39CHAPTER03L from '@/components/xhtml/39-chapter03l'
 import XHTML40CHAPTER04 from '@/components/xhtml/40-chapter04'
 import XHTML41CHAPTER04A from '@/components/xhtml/41-chapter04a'
 import XHTML42CHAPTER04B from '@/components/xhtml/42-chapter04b'
 import XHTML43CHAPTER04C from '@/components/xhtml/43-chapter04c'
 import XHTML44CHAPTER04D from '@/components/xhtml/44-chapter04d'
 import XHTML45CHAPTER04E from '@/components/xhtml/45-chapter04e'
 import XHTML46CHAPTER04F from '@/components/xhtml/46-chapter04f'
 import XHTML47CHAPTER04G from '@/components/xhtml/47-chapter04g'
 import XHTML48CHAPTER04H from '@/components/xhtml/48-chapter04h'
 import XHTML49CHAPTER04I from '@/components/xhtml/49-chapter04i'
 import XHTML50CHAPTER04J from '@/components/xhtml/50-chapter04j'
 import XHTML51CHAPTER04K from '@/components/xhtml/51-chapter04k'
 import XHTML52CHAPTER04L from '@/components/xhtml/52-chapter04l'
 import XHTML53CHAPTER05 from '@/components/xhtml/53-chapter05'
 import XHTML54CHAPTER05A from '@/components/xhtml/54-chapter05a'
 import XHTML55CHAPTER05B from '@/components/xhtml/55-chapter05b'
 import XHTML56CHAPTER05C from '@/components/xhtml/56-chapter05c'
 import XHTML57CHAPTER05D from '@/components/xhtml/57-chapter05d'
 import XHTML58CHAPTER05E from '@/components/xhtml/58-chapter05e'
 import XHTML59CHAPTER05F from '@/components/xhtml/59-chapter05f'
 import XHTML60CHAPTER05G from '@/components/xhtml/60-chapter05g'
 import XHTML61CHAPTER05H from '@/components/xhtml/61-chapter05h'
 import XHTML62CHAPTER05I from '@/components/xhtml/62-chapter05i'
 import XHTML63CHAPTER05J from '@/components/xhtml/63-chapter05j'
 import XHTML64CHAPTER05K from '@/components/xhtml/64-chapter05k'
 import XHTML65CHAPTER05L from '@/components/xhtml/65-chapter05l'
 import XHTML66CHAPTER05M from '@/components/xhtml/66-chapter05m'
 import XHTML67CHAPTER06 from '@/components/xhtml/67-chapter06'
 import XHTML68CHAPTER06A from '@/components/xhtml/68-chapter06a'
 import XHTML69CHAPTER06B from '@/components/xhtml/69-chapter06b'
 import XHTML70CHAPTER06C from '@/components/xhtml/70-chapter06c'
 import XHTML71CHAPTER06D from '@/components/xhtml/71-chapter06d'
 import XHTML72CHAPTER06E from '@/components/xhtml/72-chapter06e'
 import XHTML73CHAPTER06F from '@/components/xhtml/73-chapter06f'
 import XHTML74CHAPTER06G from '@/components/xhtml/74-chapter06g'
 import XHTML75CHAPTER06H from '@/components/xhtml/75-chapter06h'
 import XHTML76CHAPTER06I from '@/components/xhtml/76-chapter06i'
 import XHTML77CHAPTER06J from '@/components/xhtml/77-chapter06j'
 import XHTMLLOVE_2 from '@/components/xhtml/love_2'
 import XHTML78INDEX from '@/components/xhtml/78-index'
 import XHTML79IMAGES from '@/components/xhtml/79-images'
 import XHTML80AUTHOR from '@/components/xhtml/80-author'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/xhtml/07-contents",
 			"name" : "xhtml/07-contents",
 			"component" : XHTML07CONTENTS
 		},
 		{
 			"path" : "/xhtml/08-foreword",
 			"name" : "xhtml/08-foreword",
 			"component" : XHTML08FOREWORD
 		},
 		{
 			"path" : "/xhtml/09-introduction",
 			"name" : "xhtml/09-introduction",
 			"component" : XHTML09INTRODUCTION
 		},
 		{
 			"path" : "/xhtml/10-chapter01",
 			"name" : "xhtml/10-chapter01",
 			"component" : XHTML10CHAPTER01
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js